"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createBackendRequestOptions = createBackendRequestOptions;
exports.createResourceRequestOptions = createResourceRequestOptions;
var _coreLog = _interopRequireDefault(require("../core-log"));
var _coreMerge = _interopRequireDefault(require("../core-merge"));
var _coreOnline = _interopRequireDefault(require("../core-online"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/*
* Copyright (c) 2020 Wells Fargo, All rights reserved.
*
* This software is the confidential and proprietary information of Wells Fargo
* bank. ('Confidential Information'). You shall not disclose such Confidential
* Information and shall use it only in accordance with the terms of the license
* agreement you entered into with WellsFargo.
*/

/**
 * Sets up AJAX options for a resource request
 *
 * @param {string} label A descriptive label for this request
 * @param {object} options The options of the request
 * @return {object} Updated options object for this request
 */
function createResourceRequestOptions(label, options) {
  var defaults = {
    'method': 'GET'
  };
  var opts = _coreMerge["default"].merge({}, defaults, options);
  if (!_coreOnline["default"].isOnline()) {
    if (typeof opts.noInternetConnectionCallback === 'function') {
      opts.noInternetConnectionCallback();
    }
    return undefined;
  }

  // ensure there is a success callback
  if (!opts.success) {
    _coreLog["default"].log(label + ' method requires a \'success\' callback.');
    return undefined;
  }

  // ensure there is a failure callback
  if (!opts.failure) {
    _coreLog["default"].log(label + ' method requires a \'failure\' callback.');
    return undefined;
  }
  return opts;
}

/**
 * Sets up AJAX options for a backend request
 *
 * @param {string} label A descriptive label for this request
 * @param {object} options The options of the request
 * @return {object} Updated options object for this request
 */
function createBackendRequestOptions(label, options) {
  var defaults = {
    'noInternetConnectionCallback': undefined,
    'requestTimeoutCallback': undefined
  };
  var opts = _coreMerge["default"].merge({}, defaults, options);
  if (!_coreOnline["default"].isOnline()) {
    if (typeof opts.noInternetConnectionCallback === 'function') {
      opts.noInternetConnectionCallback();
    }
    return undefined;
  }

  // ensure there is a success callback
  if (!opts.success) {
    _coreLog["default"].log(label + ' method requires a \'success\' callback.');
    return undefined;
  }

  // ensure there is a failure callback
  if (!opts.failure) {
    _coreLog["default"].log(label + ' method requires a \'failure\' callback.');
    return undefined;
  }
  return opts;
}
//# sourceMappingURL=request-options.js.map